import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const SearchIcon = (props) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9999 16.6099L21.7099 20.2899C22.0846 20.6775 22.0846 21.2923 21.7099 21.6799C21.5222 21.8692 21.2666 21.9757 20.9999 21.9757C20.7333 21.9757 20.4777 21.8692 20.2899 21.6799L16.6099 17.9999C12.8816 20.9901 7.46619 20.5447 4.27656 16.9854C1.08693 13.4262 1.23556 7.99456 4.61506 4.61506C7.99456 1.23556 13.4262 1.08693 16.9854 4.27656C20.5447 7.46619 20.9901 12.8816 17.9999 16.6099ZM10.9999 3.99992C7.13393 3.99992 3.99992 7.13393 3.99992 10.9999C3.99992 14.8659 7.13393 17.9999 10.9999 17.9999C14.8659 17.9999 17.9999 14.8659 17.9999 10.9999C17.9999 7.13393 14.8659 3.99992 10.9999 3.99992Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

SearchIcon.propTypes = {
  sx: PropTypes.object,
};

export default SearchIcon;
